module.exports = __webpack_public_path__ + "img/1.945212a5.jpg";